// Module
var code = "<h2 id=\"helpful-tools\">Helpful Tools</h2> <ul> <li> <a href=\"/sitemap\">Site Map</a></li> <li> <a href=\"http://get.adobe.com/reader/\">Get Adobe Reader</a></li> </ul> ";
// Exports
export default code;